var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',{staticClass:"header"},[_c('img',{attrs:{"src":require("../../assets/xseed.png"),"width":"220px"}}),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.$t('xseed')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }